<template>
  <q-page padding>
    <div class="form-container minimo">
      <div class="header">
        <img :src="logoUrl" class="logo" />
        <div
          class="title"
          style="background-color: #cc0000; border-radius: 5px; color: white"
        >
          SOLICITAÇÃO DE COMPRA / CONTRATAÇÃO
        </div>
      </div>

      <table class="info-table">
        <tr>
          <td style="background-color: #ffff00">
            <strong>Nº ALMOX:</strong>
            <span
              style="font-size: 14px; font-weight: bold"
              class="q-ml-sm text-brand-2"
              >{{ form.numero }}</span
            >
          </td>
          <td><strong>Nº COMPRAS</strong></td>
          <td class="highlight">
            <strong>DATA DE SOLICITAÇÃO:</strong>
            {{
              form.cricao_necessidade
                ?.split(" ")[0]
                ?.split("-")
                ?.reverse()
                ?.join("/")
            }}
            {{ form?.cricao_necessidade?.split(" ")[1] }}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <strong>Solicitante:</strong> {{ form.solicitante_nome }}
          </td>
          <td>
            <strong>CLASSIFICAÇÃO DE SOLICITAÇÃO DE COMPRA:</strong>

            <span
              class="q-ml-sm"
              style="font-size: 14px; font-weight: bold"
              :style="{ color: setColorTag(form.tag) }"
              >{{ form.tag }}
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <strong>Local de aplicação:</strong> {{ form.cost_center_name }}
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <strong>Data de aplicação:</strong>
            {{
              form.data_aplicacao
                ?.split(" ")[0]
                ?.split("-")
                ?.reverse()
                ?.join("/")
            }}
          </td>
        </tr>
      </table>

      <table class="product-table">
        <thead>
          <tr>
            <th>CÓDIGO MATERIAL</th>
            <th>UNIDADE DE CONTROLE</th>
            <th>RESPONÁVEL COMPRA</th>
            <th>FAMÍLIA</th>
            <th>DESCRIÇÃO</th>
            <th>QUANT.</th>
            <th>UNID</th>
            <th>CUSTO ORÇ.</th>
            <th>TOTAL ORÇADO</th>
            <th>EXCLUIR</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in produtos"
            :key="index"
            :class="{ zebra: index % 2 !== 0 }"
          >
            <td style="background-color: #b6dde8">
              {{ item?.product_codigo || "" }}
            </td>
            <td>{{ item?.item_cost_center_code || "" }}</td>
            <td>{{ item?.responsavel_nome || "" }}</td>
            <td style="background-color: #fde9d9">
              {{ item?.codigo_categoria || "" }}
            </td>
            <td>{{ item?.produto_nome || "" }}</td>
            <td>{{ formatQuantidade(item?.quantidade_necessaria) || "" }}</td>
            <td>{{ item?.unidade_medida || "" }}</td>
            <td></td>
            <td></td>
            <td>
              <q-btn
                flat
                color="negative"
                icon="delete"
                @click="produtos.splice(index, 1)"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="section"><strong>TOTAL ORÇADO:</strong></div>
      <div class="section">
        <strong>PRAZO INÍCIO: </strong>
        {{
          form.data_aplicacao?.split(" ")[0]?.split("-")?.reverse()?.join("/")
        }}
        &nbsp;&nbsp;
        <strong>FIM:</strong>
      </div>

      <div class="section">
        <strong
          style="
            display: flex;
            justify-content: center;
            background-color: #996666;
            color: white;
          "
          >DETALHAMENTO TÉCNICO / INSTRUÇÕES ESPECIAIS</strong
        >
        <section class="line">
          <div style="display: flex; min-height: 25px; align-items: center">
            <span
              style="
                width: 90px;

                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              "
              >1</span
            >
            <div style="border-left: 1px solid black" class="q-ml-sm">
              {{ form.detalhamento_tecnico }}
            </div>
          </div>
        </section>
      </div>

      <div class="section">
        <strong
          style="
            display: flex;
            justify-content: center;
            color: white;
            background-color: #996666;
          "
          >POSSÍVEIS FORNECEDORES</strong
        >

        <section class="line">
          <div style="display: flex; min-height: 25px; align-items: center">
            <span
              style="
                width: 90px;

                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              "
              >1</span
            >
            <div style="border-left: 1px solid black" class="q-ml-sm">
              {{ form.possiveis_fornecedores }}
            </div>
          </div>
        </section>
      </div>

      <div class="section">
        <strong
          style="
            display: flex;
            justify-content: center;
            color: white;
            background-color: #996666;
          "
          >RESPONSABILIDADES:</strong
        >
        <div class="columns">
          <table class="product-table">
            <thead>
              <tr>
                <th>Nº</th>
                <th>CONTRATANTE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{{ form.responsabilidades_contratante }}</td>
              </tr>
            </tbody>
          </table>
          <table class="product-table">
            <thead>
              <tr>
                <th>FORNECEDOR</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ form.responsabilidades_fornecedores }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="section">
        <strong
          style="
            display: flex;
            justify-content: center;
            color: white;
            background-color: #996666;
          "
          >JUSTIFICATIVA DA CONTRATAÇÃO / COMPRA</strong
        >
        <div
          style="text-align: center; color: #ff0000; font-weight: bold"
          class="box"
        >
          {{ form.justificativa_contratacao }}
        </div>
      </div>

      <div class="footer">
        <table>
          <tr>
            <th colspan="2" class="header-red">
              REQUISITOS NECESSÁRIOS PARA SOLICITAÇÃO DE MATERIAIS / SERVIÇOS /
              LOCAÇÕES:
            </th>
          </tr>
          <tr>
            <td>1</td>
            <td>
              Todas as especificações técnicas (detalhamento dos insumos,
              serviços, projetos (quando necessário) e etc)
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td>Critérios de qualidade</td>
          </tr>
          <tr>
            <td>3</td>
            <td>
              Critérios de compra / contratação (necessidades específicas para
              compra dos materiais, contratação de serviços ou solicitações
              específicas ao fornecedor)
            </td>
          </tr>
          <tr>
            <td>4</td>
            <td>Prazo de necessidade dos insumos / serviços</td>
          </tr>
          <tr>
            <td>5</td>
            <td>Valor de custo dos insumos / serviços</td>
          </tr>
          <tr>
            <td>6</td>
            <td>
              Enviar as Solicitações de Compra / Contratação separadas por
              grupos (Exemplo: Ferramentas, Agregados, Fundação, Terraplanagem e
              etc.) cada Solicitação deve ter apenas um grupo de insumos ou um
              grupo de serviços.
            </td>
          </tr>
          <tr>
            <td>7</td>
            <td>
              Todos os campos devem estar preenchidos pelo solicitante exceto o
              código de materiais que será preenchido pelo almoxarifado.
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <th colspan="2" class="header-blue">
              PRAZOS PARA FECHAMENTO DE MATERIAIS POR CONTRATO MACRO
            </th>
            <th class="header-blue">CONSIDERAÇÕES DE CONTRATO MACRO</th>
          </tr>
          <tr>
            <td colspan="2">
              <strong
                >Solicitação <span style="color: green">Normal</span>:</strong
              >
              As classificações de solicitação de compra denominada como
              <strong><span style="color: green">“Normal”</span></strong>
              referem-se à aquisições de bens ou serviços planejadas com
              antecedência <u>não</u> impactando no avanço/evolução das frentes
              de produção. As compras classificadas como
              <strong><span style="color: green">“Normal”</span></strong>
              deverão ter o prazo 7 dias para conclusão do processo de
              compra.<br /><br />
              <strong
                >Solicitação
                <span style="color: #6b81bd">Urgente</span>:</strong
              >
              As solicitações de compra denominadas como
              <strong><span style="color: #6b81bd">“Urgente”</span></strong>
              referem-se à aquisições de bens ou serviços não planejadas cuja
              falta impacta no avanço/evolução das frentes de produção e demais
              áreas. As compras classificadas como
              <strong><span style="color: #6b81bd">“Urgente”</span></strong>
              devem ser devidamente justificadas e aprovadas pelo Gerente da
              área e terá o prazo de 4 dias para conclusão do processo de
              compra.<br /><br />
              <strong
                >Solicitação
                <span style="color: #ff0000">Máquina parada</span>:</strong
              >
              As solicitações de compras denominadas como
              <strong><span style="color: red">“Máquina parada”</span></strong>
              referem-se à aquisições de materiais ou serviços emergenciais
              relacionados à área de Máquinas ou outra frente que esteja parada
              ou irá parar devido a uma falha não prevista, cuja falta impacta
              na eficiência mecânica do equipamento, no cronograma físico de
              produção, causando prejuízo ou comprometendo o cronograma
              executivo da obra. As compras classificadas como
              <strong
                ><span style="color: #ff0000">“Máquina parada”</span></strong
              >
              deverão estar justificadas e aprovadas pelo gerente/responsável
              pelo departamento e terá o prazo de 2 dias para conclusão do
              processo de compra.
            </td>
            <td>
              A data de solicitação será considerada quando todos os dados forem
              preenchidos corretamente, bem como a descrição do material estiver
              definida corretamente.<br /><br />
              Para Contratos Macro, a aprovação dos gerentes de departamento
              pode ser solicitada para os valores ou quantidades que são
              considerados importantes.
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <th colspan="2" class="header-red">
              PRAZOS PARA FECHAMENTO DE MATERIAIS SUPRIMENTOS:
            </th>
            <th class="header-red">
              PRAZOS NECESSÁRIOS PARA FECHAMENTO DE SERVIÇOS:
            </th>
          </tr>
          <tr>
            <td>
              <strong>Compras de Materiais de rotina:</strong><br />
              <strong
                >Solicitação
                <span style="color: #00b050"> Normal</span>:</strong
              >
              15 dias<br />
              <strong
                >Solicitação
                <span style="color: #6b81bd"> Urgente</span>:</strong
              >
              10 dias
            </td>
            <td>
              <strong>Compras Especiais:</strong> 30 dias - Materiais que
              demandam ampla pesquisa de mercado, detalhada da especificação e
              de projetos, custo de aquisição significativo, grande volume de
              itens, etc.<br /><br />
              <strong
                >Compras <span style="color: #ff0000">Máquina parada</span>:
              </strong>
              abaixo dos prazos acima - Indicar a justificativa na solicitação
              de compra. (Mensalmente será gerado relatório de acompanhamento
              das compras emergenciais por área demandante.)
            </td>
            <td>
              <strong>Contratações gerais:</strong> Até 30 dias<br /><br />
              <strong>Contratações Especiais:</strong> Conforme cronograma de
              aquisições definido entre Área Demandante e Suprimentos - Entre 30
              dias a 60 dias<br /><br />
              <strong>Contratações Emergenciais:</strong> abaixo dos prazos
              acima - Indicar a justificativa na solicitação de compra.
              (Mensalmente será gerado relatório de acompanhamento das compras
              emergenciais por área demandante.)
            </td>
          </tr>
        </table>

        <table>
          <tr>
            <td class="important">
              Todas as solicitações de compra de materiais devem ser enviadas ao
              e-mail:
              <strong style="color: #ff0000"
                >almoxarifado.l6@acciona.com</strong
              >
            </td>
          </tr>
          <tr>
            <td class="important">
              Todas as solicitações de compra de serviços e locação de
              equipamentos devem ser enviadas ao e-mail:
              <strong style="color: #ff0000"
                >suprimentos.linha6@acciona.com</strong
              >
            </td>
          </tr>
        </table>

        <p class="highlight-red">
          IMPORTANTE: <span style="color: black">O DOCUMENTO</span>
          <u>SOMENTE SERÁ CONSIDERADO VÁLIDO</u>
          <span style="color: black"
            >CASO TENHA ASSINATURA DOS REPRESENTANTES, SENDO:
          </span>
          <strong>SOLICITANTE, GESTOR DO SOLICITANTE E GESTOR DE CUSTOS</strong>
        </p>
      </div>
    </div>
  </q-page>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";

// funcao para formatar quantidade (minimo 2 casas decimais, maximo 4)
const formatQuantidade = (value) => {
  if (!value && value !== 0) return "0,00";
  const num = Number(value);
  if (isNaN(num)) return "0,00";

  let formatted = num.toFixed(4);

  const parts = formatted.split(".");
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === "0") {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + "." + decimals;
  }

  return formatted.replace(".", ",");
};

const store = useStore();
const produtos = ref([]);
const route = useRoute();
const produtosSemReferencia = ref([]);
const $q = useQuasar();
const id = route.params.id;
const logoUrl = store.state.autenticacao.logo.logo;
const form = ref({
  numero: "",
  numero_compras: "",
  criacao_necesscricao_necessidadeidade: "",
  solicitante_nome: "",
  unidade_nome: "",
  data_aplicacao: "",
  tag: "",
  itens: [
    {
      item_cost_center_code: "A50DZ",
      produto_nome: "FITA ADESIVA DE DEMARCAÇÃO DE SOLO 48MM X 30M CINZA",
      quantidade_necessaria: 10,
      unidade_medida: "UND",
    },
  ],
  detalhamento_tecnico: "",
  possiveis_fornecedores: "",
  responsabilidades_contratante: "",
  responsabilidades_fornecedores: "",
  justificativa_contratacao:
    "MATERIAIS COR CINZA PARA COMPLEMENTAÇÃO DOS ITENS PEDIDOS PARA CATALOGAR E AUXILIAR NO ARMAZENAMENTO DAS PEÇAS RETIRADAS DA TBM NORTE.",
});

const getSemReferencia = async () => {
  try {
    const response = await store.dispatch("compras/getSemReferencia", {
      uuid: id,
      data_inicial: "01/01/2001",
      per_page: 1000,
      associado: undefined,
      comprado: undefined,
    });

    produtosSemReferencia.value = response.data.data;

    // mapear os produtos sem referencia para o formato correto da tabela
    const produtosSemRef = produtosSemReferencia.value.map((item) => ({
      ...item,
      product_codigo: item.product_codigo || "",
      produto_nome: item.produto_nome || item.descricao || "",
      quantidade_necessaria:
        item.quantidade_necessaria || item.quantidade || "",
      unidade_medida: item.unidade_medida || item.medida || "",
      item_cost_center_code: item.item_cost_center_code || "",
      responsavel_nome: item.responsavel_nome || "",
      codigo_categoria: item.codigo_categoria || "",
    }));

    // adicionar os produtos sem referencia ao array de produtos
    produtos.value = [...produtos.value, ...produtosSemRef];

    // preencher os dados do formulario com o primeiro item se disponivel
    if (
      Object.keys(form.value).length === 13 &&
      produtosSemReferencia.value.length > 0
    ) {
      form.value = { ...produtosSemReferencia.value[0] };
      if (form.value?.product_codigo == null) {
        form.value.product_codigo = "";
      }
    }
  } catch (error) {
    $q.notify({
      message: "Erro ao carregar produtos sem referência",
      color: "negative",
    });
  }
};

const getDados = async () => {
  try {
    store.dispatch("pdt/hiddenHeader", false);
    const response = await store.dispatch("compras/acompanhar", {
      uuid: id,
    });

    if (response.data?.data?.length > 0) {
      form.value = response.data.data[0];
      produtos.value = response.data.data;
    } else {
      // Se não há dados principais, inicializar array vazio para receber produtos sem referência
      produtos.value = [];
    }

    // Sempre chamar getSemReferencia para carregar produtos sem código
    await getSemReferencia();
  } catch (error) {
    $q.notify({
      message: "Erro ao carregar dados da necessidade",
      color: "negative",
    });

    // Mesmo em caso de erro, tentar carregar produtos sem referência
    produtos.value = [];
    await getSemReferencia();
  }
};

onMounted(getDados);

const setColorTag = (tag) => {
  switch (tag) {
    case "normal":
      return "#00b050";
    case "urgente":
      return "#6b81bd";
    case "maquina parada":
      return "#ff0000";
    default:
      return "black";
  }
};
</script>

<style scoped>
.form-container {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  color: #000;
  font-family: Arial, sans-serif;
  font-size: 11px;
}

.header {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #000;
  padding-bottom: 8px;
  margin-bottom: 8px;
  page-break-after: avoid;
}
.logo {
  width: 100px;
  margin-right: 20px;
}
.title {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  flex-grow: 1;
  text-transform: uppercase;
}

.info-table,
.product-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;
}
.info-table {
  page-break-after: avoid;
}
.product-table {
  page-break-inside: auto;
}
.info-table td,
.product-table th,
.product-table td {
  border: 1px solid #000;
  padding: 6px;
  font-size: 11px;
  text-transform: uppercase;
}
.product-table th {
  background-color: #e0e0e0;
  font-size: 11px;
}
.product-table .zebra {
  background-color: #f7f7f7;
}
.product-table thead {
  page-break-after: avoid;
}
.product-table tbody tr {
  page-break-inside: avoid;
}

.section {
  margin-top: 5px;
  margin-bottom: 5px;
  text-transform: uppercase;
  font-size: 11px;
  page-break-inside: avoid;
}
.box {
  border: 1px solid #000;
  padding: 8px;
  min-height: 50px;
  background-color: #fdfdfd;
  font-size: 11px;
}

.line {
  border: 1px solid #000;
  font-size: 11px;
}
.columns {
  display: flex;
  justify-content: space-between;
  page-break-inside: avoid;
}
.columns table {
  width: 50%;
}

.footer {
  border-top: 2px solid #000;
  padding-top: 8px;
  margin-top: 15px;
  font-size: 11px;
  page-break-before: auto;
}
.footer table {
  width: 100%;
  border-collapse: collapse;
  page-break-inside: avoid;
  margin-bottom: 8px;
}
.footer th,
.footer td {
  border: 1px solid black;
  padding: 6px;
  text-align: left;
  vertical-align: top;
  font-size: 11px;
}
.footer .header-red {
  background-color: #e74c3c;
  color: white;
  font-weight: bold;
  text-align: center;
}
.footer .header-blue {
  background-color: #2980b9;
  color: white;
  font-weight: bold;
  text-align: center;
}
.footer .highlight-red {
  color: red;
  font-weight: bold;
}
.footer .important {
  background-color: #f2f2f2;
  font-style: italic;
  font-size: 11px;
}

@media print {
  html,
  body {
    width: 210mm;
    height: 297mm;
    margin: 0;
    padding: 10mm;
    background: white;
    font-family: Arial, sans-serif;
    font-size: 11px;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .form-container {
    max-width: 100%;
  }

  .header {
    margin-bottom: 6px;
    padding-bottom: 6px;
  }

  .info-table,
  .product-table {
    margin-bottom: 6px;
  }

  .section {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .footer {
    margin-top: 10px;
  }

  .footer table {
    margin-bottom: 6px;
  }

  .product-table th:last-child,
  .product-table td:last-child {
    display: none !important;
  }
}
</style>
